export function formatSignedMoney(num: number) {
  return num.toLocaleString("da-DK", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    signDisplay: "always"
  });
}
export function formatSignedDecimal(num: number) {
  return num.toLocaleString("da-DK", {
    style: "decimal",
    signDisplay: "always"
  });
}
export function formatMoney(num: number) {
  return num.toLocaleString("da-DK", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
export function formatDecimal(num: number) {
  return num.toLocaleString("da-DK", {
    style: "decimal"
  });
}
export function formatPercent(num: number) {
  return num.toLocaleString("da-DK", {
    style: "percent"
  });
}
